import { type ReactNode, useState } from "react";

export type CoverageAccordionPanel = {
  expanded: boolean;
  onToggle: () => void;
};

type Props = {
  journeysExpanded: boolean;
  pagesExpanded: boolean;
  journeys: (panel: CoverageAccordionPanel) => ReactNode;
  pages: (panel: CoverageAccordionPanel) => ReactNode;
};

export default function CoverageAccordion({ journeysExpanded, pagesExpanded, journeys, pages }: Props) {
  const [journeysOpen, setJourneysOpen] = useState(journeysExpanded);
  const [pagesOpen, setPagesOpen] = useState(pagesExpanded);

  const journeysPanel = journeys({
    expanded: journeysOpen,
    onToggle: () => setJourneysOpen((open) => !open),
  });
  const pagesPanel = pages({
    expanded: pagesOpen,
    onToggle: () => setPagesOpen((open) => !open),
  });

  if (journeysExpanded) {
    return (
      <>
        {journeysPanel}
        {pagesPanel}
      </>
    );
  }

  return (
    <>
      {pagesPanel}
      {journeysPanel}
    </>
  );
}
